module.exports = __webpack_public_path__ + "img/gpje.242bb4cc.png";